const landingDictEN = {
  home: "Home",
  benefits: "Benefits",
  benefitsExplanation: "Our platform is a modern, easily accessible and profitable tool.",
  firstBenefit: "Greater commercial integration",
  secondBenefit: "Lighter and more powerful economy",
  thirdBenefit: "Instant and consistent profit opportunity",
  fourthBenefit: "Generate credit",
  features: "Features",
  howItWorks: "How it works",
  meetOurPlans: "Meet our plans",
  join: "Our plans",
  plans: "Plans",
  login: "Sign in",
  whatIsIt: "The marketplace that always rewards you",
  whatIsItExplanation:
    "Extraconomy is an online cooperative economy platform with a system of rewards and geolocations that allows individuals and companies to increase their economic power and their network of customers in an automatic and progressive manner, through the various activities carried out on the marketplace.",
  why: "Why?",
  greaterBusiness: "Greater business integration",
  lighterPowerful: "Lighter and more powerful economy",
  instantProfit: "Instant and consistent profit opportunity",
  genCredit: "Generate credit",
  whyShould: "Why should I join ExtraConomy?",
  seeBelow: "See below the features of our social and economic circle:",
  extracredit: "Extracredit",
  extracoinExplanation:
    "Register and earn Extracredit (see conditions). Use the credit to buy and/or share with your friends.",
  indicate: "Earn Extracredit Credits",
  youMayGain: "Refer users to your network and earn Extracredit and real money.",
  economicNetwork: "Economic Network",
  networkOfUsers: "Build user network to buy and sell products and services.",
  transactionSafety: "Transaction Security",
  ourPlatform: "Our platform is robust and secure. You can buy, sell and transfer money securely.",
  findEverything: "Find Everything You Need",
  weHavePowerfulTool:
    "We have a powerful tool to find the product you are looking to purchase in a few clicks.",
  buyerReviews: "Buyer Reviews",
  checkTheReviews: "Check reviews from users who have purchased the product you are looking for.",
  geolocation: "Geolocation",
  effectiveTools: "Effective tools to automatically grow your economic network.",
  exceptionalTrading: "Exceptional Business",
  saferMoreFrequent: "Safer, frequent and advantageous exchanges.",
  economicInfluence: "Economic Influence",
  sellFaster: "Make sales faster, buy more easily, always making a profit.",
  howItWorksExplanation:
    "You receive rewards for each activity that takes place on the platform, in the form of money and Extracredit credits that can be used within the system as an economic complement in commercial exchanges.",
  learnMore: "Learn more",
  doubts: "Doubts? ",
  contactToUs: "Contact us.",
  belowArePlans: "Join the Extraconomy. Below are the types of plans available on our service.",
  contact: "Contact",
  contactWhatTele:
    "For information about the project and about opening the market for Partners and Managers in a Country, write to the following Whatsapp and Telegram contacts.",
  joinExtraconomy: "Join the Extraconomy.",
  scanQRCode: "Scan the QR Code below to contact us via WhatsApp or Telegram:",
  highlights: "Highlights",
  by: " by ",
  video: "Video",
  introVideo: "Intro video about our platform:",
  backToHomePage: "Back to the Home Page",
  qrCodeExplanation:
    "For information about the project and about opening the market for Partners and Managers in a Country, write to the following Whatsapp and Telegram contacts:",
  socialMedia: "Social Media",
  rightsReserved: "All Rights Reserved",
  checkApp: "Check our app",
  customerDescription: "Just for shopping",
  partnerDescription: "For sales and purchases",
  managerDescription: "E-commerce + Purchasing",
  benefitsExtracoinSection: "Benefits when purchasing Extracoin",
  extracoinBenefitTitle1: "2.000 Extracoins: Become a Partner at Extraconomy!",
  extracoinBenefitDescription1:
    "Holders of 2.000 Extracoins receive a free voucher to become Partners on the Extraconomy Marketplace. Join the revolution and actively participate in shaping the future of the digital economy.",
  extracoinBenefitTitle2: "5.000 Extracoins: Unlock Seller Status at Extraconomy!",
  extracoinBenefitDescription2:
    "Holders of 5.000 Extracoins are rewarded with a free voucher to become Sellers on the Extraconomy platform. Showcase your products and services to a global audience.",
  extracoinBenefitTitle3: "15.000 Extracoins: Reach Manager Status at Extraconomy!",
  extracoinBenefitDescription3:
    "Holders of 15.000 Extracoins receive an exclusive voucher to become Managers at Extraconomy. Immerse yourself in the management universe and contribute to the growth of the entire ecosystem.",
  voucherExtracoinText1: "Already have a ",
  clickHere: "Click here",
  andRegister: "and register",
  voucherEmptyError: "Voucher cannot be empty",
  extracoinVoucherError: "Invalid voucher",
  startsWith: "Starts with",
  contains: "Contains",
  notContains: "Does not contain",
  endsWith: "Ends with",
  equals: "Equals",
  notEquals: "Not equals",
  noFilter: "No filter",
  joinTheLaunchpad: "Join the Launchpad of our Extracoin token on Cryptosmart!",
  popupDesc:
    "When purchasing EXC tokens at a special price, you will receive a free voucher in return to open an online store on the Extraconomy marketplace, activating your daily income!",
  exclusiveBenefits: "Exclusive Benefits",
  popupPartnerTitle: "Become a Partner!",
  popupPartnerDesc:
    "*When purchasing a minimum of 2,000 Extracoin you will receive a free voucher to open a sales outlet on the Extraconomy marketplace.",
  popupSellerTitle: "Unlock the Seller profile!",
  popupSellerDesc:
    "*When purchasing at least 5,000 Extracoin you will receive a free voucher to open an e-commerce on the Extraconomy platform.",
  popupManagerTitle: "Reach Manager status!",
  popupManagerDesc:
    "*When purchasing a minimum of 15,000 Extracoin you will receive an exclusive voucher to open an online store at Extraconomy with all benefits included.",
  promotionValidUntilEndLaunchpad: "Promotion valid until the end of Launchpad",
  downloadAppAndEarn: "Download the app now and earn 20 euros in credits immediately",
  frequentlyAskedQuestion: "Frequently Asked Questions",
  faqTitle1: "Is the Extraconomia platform safe?",
  faqAnswer1:
    "Yes, we have a technical team specialized in information security. All content, data and financial operations on the platform are protected against multiple levels of security, so that we can mitigate as much as possible any type of computer attack that can be verified.",
  faqTitle2: "How can I participate in the platform?",
  faqAnswer2:
    "If you discovered Extraconomy through someone, they know how to get you on the platform. Otherwise, download our App and register by entering your details to access the Store directly. You will receive a welcome credit to use on your future purchases!",
  faqTitle3: "Are there registration fees to be able to sell my products or services?",
  faqAnswer3:
    "Yes, to have a space for your storefront or for your e-commerce there are 3 sales plans with different values and benefits depending on the needs of each individual and business user. You can discover the Plans directly here on this website.",
  faqTitle4:
    "When I carry out promotional and sales activities on the Extraconomy platform, do I have an employment relationship?",
  faqAnswer4:
    "No, if you have subscribed to one of the 3 sales plans you will be autonomous and will be fully responsible for your expenses. Only if you decide to work with us as a Promoter will you receive a Sales Representative contract.",
  faqTitle5: "How can I request deletion of my account?",
  faqAnswer5:
    "To cancel your Extraconomy account, simply log in to your Personal Area and then click Edit Profile to request the cancellation of the account at no additional cost. Or you can send a message to Whatsapp +39 351 767 0019 with the subject “Account Cancellation”.",
  faqTitle6: "I'm new to the platform, is there any support?",
  faqAnswer6:
    "Yes, we have humanized and dedicated support to help you whenever you need it through the Whatsapp and Telegram channels that you can find among our contacts here on the website.",
  faqTitle7: "I provided the wrong email, what now?",
  faqAnswer7:
    "To change your email, you will need to send a message to WhatsApp +39 351 767 0019 with the subject “Change email”, providing all the registration details used during registration and the correct email address.",
  faqTitle8: "What are the payment options?",
  faqAnswer8:
    "Through PayPal, our international payment gateway, you can pay for your order by credit card, debit card or bank account.",
  faqTitle9: "How much does shipping cost to my region?",
  faqAnswer9:
    "For this calculation, the easiest way is to simulate your order. Choose the items with Shipping Paid, add them to the cart and complete the purchase, enter your details correctly (very important) and at the end of the order the website will show the correct shipping cost. If you are just simulating, do not click Checkout and it will not result in any real purchase on your part. Then edit the items and quantities to see the differences, feel free.",
  faqTitle10: "How do credits acquired on Extraconomy work?",
  faqAnswer10:
    "Internal credits are acquired through the various activities carried out on the platform (Registrations, Buy-Sell and Sharing) in the form of cashbacks, prizes and bonuses, which can be used in a complementary way in purchases within the platform or in marketing activities based on terms of use provided for each user profile. ",
  faqTitle11:
    "How can I monitor and manage my payments, commissions and bonuses received on Extraconomy?",
  faqAnswer11:
    "When registering via the Web and the App, you receive a virtual office in your Personal Area where you can monitor all your direct financial income and those from your economic circle.",
  faqTitle12: "How do I receive my financial income?",
  faqAnswer12:
    "Direct and indirect economic income is credited to your PayPal account, which you must enter in your Personal Area. If you don't have a PayPal account, you can create one for free at www.paypal.com.",
  SeeTheRegulationsHere: "See the regulations here",
  joinTheLaunchpadButton: "Join the Launchpad",
  tax: "Tax",
  workWithUs: "Work with us",
  jobOpportunity: "Job opportunity",
  workWithUsText1:
    "The Extraconomy system offers the possibility of participating in online and territorial development through key figures (web promoter, ambassador, sales agent, micro-influencer, market affiliates) who will automatically benefit from an exclusive, scalable and rewarding commission system.",
  freePlan: "Free",
  salesRepresentativeContract: "Sales representative contract",
  earnCommissionsAndCredits: "Earn commissions and credits",
  developYourNetwork: "Develop your network",
  financialCareerAwards: "Financial and career awards",
  resources: "Resources",
  blog: "Blog",
  toTheStore: "ACCESS THE STORE",
  revolutionizeWithExtraconomy: "Revolutionize the economy with Extraconomy",
  revolutionizeWithExtraconomyDescription:
    "Transform your daily expenses into earnings and participate in a sustainable economy.",
  iWantToStart: "I want to revolutionize the economy.",
  extrapayBalance: "Extrapay balance",
  extracreditBalance: "Extracredit balance",
  viewCashback: "View cashback statement",
  partnerPlan: "Partner plan",
  empowerYourBusiness: "Empower your business",
  empowerYourBusinessDescription:
    "Extraconomy is an economic model that unites technology, community and cooperation. We created an innovative system that amplifies the economic power of people and supports local activities.",
  comercialIntegration: "Greater commercial integration",
  comercialIntegrationDescription:
    "Our tools empower the integration between stores and customers, based on the geolocation model.",
  powerfulEconomy: "A more rapid and powerful economy",
  powerfulEconomyDescription:
    "We reinforce the local economy and help local businesses gain more visibility.",
  instantProfitDescription:
    "With the active economic circle, start earning money from the moment of registration and expand with purchases and recommendations.",
  generateCredit: "Generate more credit",
  generateCreditDescription: "You can earn money while making daily purchases.",
  advantages: "We have many advantages for you",
  createAnAccountForFree: "Create a free account and discover all the benefits",
  createAnAccountForFree2: "can offer you",
  geolocalization: "Geolocation",
  geolocalizationDescription: "Discover local services and companies and reinforce your region.",
  coperativeEconomy: "Cooperative Economy",
  coperativeEconomyDescription:
    "Participate actively in the construction of a more inclusive future.",
  cashback: "Automatic Cashback",
  cashbackDescription: "Save and accumulate rewards in all your purchases.",
  pension: "Integrative Pension",
  pensionDescription: "Ensure your future with automatic savings for health and pension.",
  contactUs: "Contact us on WhatsApp",
  manyAdvantages: "There are many advantages!",
  monetaryAlternatives: "Use also our monetary alternative, you will save more by paying with ",
  monetaryAlternatives2: "utility-token Extracoin!",
  scrollDown: "Continue to explore",
  exclusiveResources: "EXCLUSIVE RESOURCES",
  whyExtraconomy: "Why should you join Extraconomy?",
  whyExtraconomyDescription:
    "With the resources of our social and economic network, you can amplify your earnings. Discover all the benefits of Extraconomy and join us.",
  newAcquisition: "New acquisition",
  newSale: "New sale",
  localSales: "Local sale with withdrawal.",
  descExtracredit:
    "Register and obtain the Extracredit (see the terms). Use the credit to buy and/or share with your friends.",
  descEconomicNetwork:
    "Create automatically a network of users to buy and sell products and services.",
  descTransactionSafety:
    "Our platform is robust and secure. You can buy, sell and transfer money in a secure way.",
  descFindEverything:
    "Find everything you need in a few clicks. We have a powerful tool to find the product you are looking to purchase.",
  plansAdvantages: "ADVANTAGE IN EACH PLAN",
  chooseYourPlanTitle: "Choose the plan that best suits your profile.",
  chooseYourPlanDescription:
    "Learn about our plans, choose the one that best fits your profile, and join Extraconomy.",
  noMonthlyFees: "NO MONTHLY FEES",
  noMonthlyPaymentsDesc: "You will not have to make monthly payments.",
  partner: "PARTNER",
  naturalPerson: "Natural person",
  salesPlan: "Sales plan",
  selectPlan: "SELECT",
  legalOrNaturalPerson: "Natural person / Legal person",
  featureShowcase: "Online showcase",
  featureEconomicNetwork: "Economic network",
  featureActiveComission: "Active commission",
  featureEcommerce: "E-commerce personal",
  featureOnlineStore: "Online store",
  featureGeolocation: "Active geolocation",
  featureEvrythingIncluded: "Everything included",
  mostPopular: "most popular",
  doubtsAboutPlans: "Do you have doubts about which plan is the best?",
  doubtsAboutPlansDesc:
    "Send a message to our customer service and we will help you choose the best plan for your profile.",
  workWithUsSubtitle: "WORK WITH US",
  workWithUsTitle: "Be a Promoter of Extraconomy and multiply your earnings.",
  workWithUsDescription:
    "The Extraconomy system offers the opportunity to participate in online and territorial development through key figures (web promoters, ambassadors, commercial agents, micro-influencers, market affiliates), who will automatically benefit from an exclusive, scalable and rewarding commission system.",
  doYouWantToWork: "Do you want to be a Promoter?",
  extracredits: "Receive 500 R$ in extra credit.",
  moreBonus: "Bonus",
  moreBonusesDescription: "Rewards for financial career.",
  recurrence: "Recurrence",
  recurrenceDescription: "Develop your network and increase your recurrence of earnings.",
  comissions: "Commissions",
  comissionsDescription: "Earn commissions and credit.",
  clarify: "Clarify your doubts",
  frequentlyAskedQuestionDescription:
    "We collect some questions and answers that may help you in your choice.",
  doubtsDescription: "Send a message to our team.",
  joinUs: "Join us",
  joinUsDescription: "Register and let's transform the economy, together.",
  talkWithUs: "Talk with our team",
  talkWithUsDescription: "Talk with our commercial team.",
  needHelp: "Need help?",
  downloadApp: "Download the app",
  call: "Call",
  callDescription: "Get in touch with us",
  buyInWhatsapp: "Buy in WhatsApp",
  buyInWhatsappDescription: "Buy in WhatsApp",
  assistance: "Call center",
  assistanceDescription: "Ask your questions",
  followUs: "Follow our official channels",
  shippingMethods: "Shipping methods",
  partners: "Partners",
  discoverExtraconomy: "Discover Extraconomy",
  rewardsProgram: "Rewards program",
  makeMoneyWithUs: "Make money",
  sellWithUs: "Sell with us",
  becomeAffiliate: "Become an affiliate",
  ourPolicies: "Our policies",
  termsAndConditions: "Terms and conditions",
  shippingPolicy: "Shipping policy",
  privacyPolicy: "Privacy policy",
  returnsAndRefunds: "Returns and refunds",
  partnerPlanDescription: "For those starting to sell online.",
  sellerPlanDescription: "For those who want to increase their sales.",
  managerPlanDescription: "For those who want to expand their business.",
  planSeller: "SELLER",
  register: "Register",
  activateYourDigitalAccess: "Activate your digital access",
  seoDescription: "An innovative online platform for cooperative and circular economy.",

  // --- Landing page redesign translations (lp2*) ---
  lp2HeroTitle: "Shall we revolutionize the economy together?",
  lp2HeroDescription: "Turn your everyday spending into earnings and take part in a more sustainable economy — built by you, with the people around you.",
  lp2HeroCta: "I want to be part of this economy.",
  lp2HeroMicrocopy: "No sign-up fee for you. No fine print.",
  lp2LocalPartner: "Local partner",
  lp2ComoFuncionaEyebrow: "How it works",
  lp2ComoFuncionaTitle: "Buy, earn benefits, and use them again.",
  lp2ComoFuncionaDescription: "You shop within the network, earn benefits, and can use them on new purchases. Meanwhile, nearby businesses gain more movement.",
  lp2Step1Label: "Buy",
  lp2Step1Title: "Shop within the network",
  lp2Step1Desc: "Find Extraconomy's physical stores and online sellers.",
  lp2Step2Label: "Earn",
  lp2Step2Title: "Your purchase generates benefits",
  lp2Step2Desc: "Earn cashback in Extracredit and perks through Extrapay.",
  lp2Step3Label: "Use",
  lp2Step3Title: "Use it on your next purchase",
  lp2Step3Desc: "Your balance stays visible in your wallet and can go toward new purchases.",
  lp2Step4Label: "Keep it circulating",
  lp2Step4Title: "The network gets stronger",
  lp2Step4Desc: "More purchases attract new businesses and increase options for everyone.",
  lp2ChoosePathEyebrow: "Choose how to take part",
  lp2ChoosePathTitle: "Start with what makes the most sense for you.",
  lp2ChoosePathDescription: "Buy, sell, refer businesses, or create your own network. The details appear whenever you want to know more.",
  lp2Card1Eyebrow: "For buyers",
  lp2Card1Title: "Buy",
  lp2Card1Desc: "Shop in the network and earn cashback.",
  lp2Card1Cta: "Learn more",
  lp2Card2Eyebrow: "For sellers",
  lp2Card2Title: "Sell",
  lp2Card2Desc: "Get a storefront, online store, or geolocated presence.",
  lp2Card2Cta: "View options",
  lp2Card3Eyebrow: "For connectors",
  lp2Card3Title: "Promote",
  lp2Card3Desc: "Introduce new businesses and help the network grow.",
  lp2Card3Cta: "Discover the Promoter program",
  lp2Card4Eyebrow: "For companies",
  lp2Card4Title: "Offer benefits",
  lp2Card4Desc: "Create benefits for employees, customers, and partners.",
  lp2Card4Cta: "Discover the solutions",
  lp2HighlightEyebrow: "For organizations",
  lp2HighlightTitle: "Create a network",
  lp2HighlightDesc: "Get your own environment powered by Extraconomy's technology.",
  lp2HighlightCta: "Discover White Label",
  lp2NegocioEyebrow: "FOR PARTNERS, SELLERS AND MANAGERS",
  lp2NegocioTitle: "We have lots of advantages for you",
  lp2NegocioDescription: "Create your account and discover all the advantages Extraconomy can offer your business, with a system that unites technology, community, and cooperation.",
  lp2NegocioItem1Title: "Greater commercial integration",
  lp2NegocioItem1Desc: "We connect stores and customers based on a geolocation model.",
  lp2NegocioItem2Title: "A faster, more powerful economy",
  lp2NegocioItem2Desc: "We strengthen local commerce and help businesses gain visibility.",
  lp2NegocioItem3Title: "Instant, consistent profit",
  lp2NegocioItem3Desc: "You earn from the moment you sign up and grow with every sale and referral.",
  lp2NegocioItem4Title: "Generate more credit",
  lp2NegocioItem4Desc: "Earn while making your own everyday purchases.",
  lp2StoreEyebrow: "FOR PHYSICAL STORES",
  lp2StoreTitle: "Become a partner establishment",
  lp2StoreDescription: "Put your store on Extraconomy's map and get found by people already near you — with free sign-up and the ecosystem's highest cashback range.",
  lp2StoreItem1Title: "100% free sign-up",
  lp2StoreItem1Desc: "No registration fee to put your physical store on the map.",
  lp2StoreItem2Title: "Active geolocation",
  lp2StoreItem2Desc: "Automatically receive the customers closest to your store.",
  lp2StoreItem3Title: "Cashback from 1% to 50%",
  lp2StoreItem3Desc: "The highest cashback range among all profiles in the ecosystem.",
  lp2StoreItem4Title: "Online store whenever you want",
  lp2StoreItem4Desc: "Activate your own e-commerce under the Seller plan whenever it makes sense.",
  lp2RecursosEyebrow: "SPECIAL FEATURES · FOR EVERYONE",
  lp2RecursosTitle: "The potential that's already yours from the very first click",
  lp2RecursosDescription: "Whether you buy, sell, or run a business — these features are already available as soon as you join Extraconomy.",
  lp2RecursosItem1Title: "Geolocation",
  lp2RecursosItem1Desc: "Discover local services and businesses and support your region.",
  lp2RecursosItem2Title: "Cooperative economy",
  lp2RecursosItem2Desc: "Actively take part in building a more inclusive future.",
  lp2RecursosItem3Title: "Transaction security",
  lp2RecursosItem3Desc: "Buy, sell, and transfer money safely.",
  lp2RecursosItem4Title: "Find everything you need",
  lp2RecursosItem4Desc: "A powerful tool to find what you want in just a few clicks.",
  lp2RecursosCashbackLabel: "€16.00 cashback",
  lp2RecursosLocalSaleLabel: "Local sale with pickup",
  lp2EcoTitle: "The more people take part, the stronger local commerce becomes",
  lp2EcoDescription: "Geolocation isn't just for finding things — it redirects spending closer to you, in a cycle that feeds itself.",
  lp2EcoStep1Title: "You buy local",
  lp2EcoStep1Desc: "Close to home, with guaranteed cashback.",
  lp2EcoStep2Title: "The seller gains visibility",
  lp2EcoStep2Desc: "Through geolocation, close to those who already buy from them.",
  lp2EcoStep3Title: "More partners sign up",
  lp2EcoStep3Desc: "Drawn in by the activity generated in the region.",
  lp2EcoStep4Title: "More options for you",
  lp2EcoStep4Desc: "And the cycle starts again, stronger every time.",
  lp2ContinueExploring: "Keep exploring",
  lp2Bar1Title: "Power up your business",
  lp2Bar1Text: "See what changes for business owners on Extraconomy.",
  lp2Bar2Title: "And that potential isn't just for sellers.",
  lp2Bar2Text: "It's for everyone who joins Extraconomy, from the very first click.",
  lp2Bar3Title: "And the more people take part, the stronger this cycle becomes.",
  lp2Bar3Text: "See how every local purchase fuels the next step.",
  lp2Bar4Title: "Now you see how it all connects.",
  lp2Bar4Text: "Time to close the loop and choose your place in it.",
  lp2Bar5Title: "Want to go further and multiply your role in this economy?",
  lp2Bar5Text: "Discover the opportunity to become a Promoter.",
  lp2PromotorEyebrow: "WORK WITH US",
  lp2PromotorTitle: "Become an Extraconomy Promoter and multiply your earnings",
  lp2PromotorDescription: "Take part in growing the network, both online and in your area. As a Promoter, you connect people and businesses and earn commissions on real sales and partnerships.",
  lp2PromotorInfoBox: "Your earnings come from real sales and partnerships — there's no payout just for inviting people.",
  lp2PromotorCard1Title: "Connect people",
  lp2PromotorCard1Desc: "Bring people and businesses closer to the network.",
  lp2PromotorCard2Title: "Connect businesses",
  lp2PromotorCard2Desc: "Expand the network's territorial presence.",
  lp2PromotorCard3Title: "Grow the network",
  lp2PromotorCard3Desc: "Strengthen real business relationships.",
  lp2PromotorCard4Title: "Earn through sales",
  lp2PromotorCard4Desc: "Commissions tied to real sales and partnerships.",
  lp2Profile: "Profile",
  lp2BadgeProSilver: "Pro Silver",
  lp2BadgeMostPopular: "Start Seller",
  lp2BadgeGeoGold: "Geo Gold",
  lp2BadgeFree: "FREE",
  lp2CashbackPartner: "Cashback from 1% to 15%",
  lp2CashbackSeller: "Cashback from 1% to 25%",
  lp2CashbackManager: "Cashback from 1% to 35%",
  lp2CashbackCustomer: "Cashback from 1% to 5%",
  lp2StorePlanDesc: "Your physical store, certified on the map.",
  lp2CustomerPlanDesc: "For those who want to shop and earn benefits.",
  lp2FeatureFreeSignup: "Free sign-up",
  lp2FeatureGeoAccount: "Geolocated account",
  lp2FeatureMapCertification: "Map certification",
  lp2FeatureEligibleCashback: "Cashback on eligible purchases",
  lp2FeatureExtracreditWallet: "Extracredit wallet",
  lp2CtaSelect: "Select",
  lp2CtaCertifyStore: "Certify store",
  lp2CtaCreateAccount: "Create account",
  lp2PlansEyebrow: "CHOOSE YOUR PROFILE",
  lp2PlansTitle: "Find the profile that fits you",
  lp2PlansDescription: "Customer and Store are free. Partner, Seller, and Manager are sales plans for different stages of your business. Promoter is also free.",
  lp2PlansCalloutTitle: "Free profiles available",
  lp2PlansCalloutDesc: "Customer and Store don't pay to get started.",
  lp2Faq1Q: "How can I join the platform?",
  lp2Faq1A: "Just create your free account — as a Customer, to shop and earn cashback, or by registering your business if you want to sell.",
  lp2Faq2Q: "Is the Extraconomy platform secure?",
  lp2Faq2A: "Yes. All transactions go through a robust security system, and your Extracredit balance is always visible in your wallet.",
  lp2Faq3Q: "Are there registration fees to sell?",
  lp2Faq3A: "Customer and Store have free sign-up. Partner, Seller, and Manager have an annual fee, depending on the size of the business.",
  lp2Faq4Q: "What is Extracoin?",
  lp2Faq4A: "It's our utility token. Using it lowers the platform fee on purchases, and it can be traded on connected exchanges.",
  lp2Faq5Q: "How does the Promoter network work?",
  lp2Faq5A: "Promoters introduce the ecosystem to new partners and earn commission on real business — never just for inviting people.",
  lp2FooterColPerfis: "Profiles",
  lp2FooterColGanheDinheiro: "Earn money",
  lp2FooterColPoliticas: "Our policies",
  lp2LinkDescubra: "Discover Extraconomy",
  lp2LinkEmpresas: "Extraconomy for Businesses",
  lp2LinkTecnologia: "Technology as a Service",
  lp2LinkMoedas: "Ecosystem currencies",
  lp2LinkAjuda: "Help Center",
  lp2LinkPerfisPlanos: "Profiles and plans",
  lp2LinkSejaPromotor: "Become a Promoter",
  lp2LinkPrivacidade: "Privacy Policy",
  lp2LinkTermos: "Terms of Use",
  lp2FooterAppHeading: "Download our app",
  lp2CustSeoDescription: "Shop in the Extraconomy network and track cashback and benefits in a free account.",
  lp2CustBadge: "Customer · free",
  lp2CustH1: "Shop in the network and get part of the value back.",
  lp2CustHeroDesc: "Your account is free. You find Extraconomy businesses, shop, and track your benefits all in one place.",
  lp2CustCta1: "Create my account",
  lp2CustCta2: "Understand the benefits",
  lp2CustBenefitsEyebrow: "For your everyday life",
  lp2CustBenefitsTitle: "Shopping gets simpler when the benefit is clear.",
  lp2CustBenefitsDesc: "You shop the way you always have. The difference is that part of that experience comes back to you within the network.",
  lp2CustBenefit1Title: "Find nearby businesses",
  lp2CustBenefit1Desc: "Discover stores, products, and services that are part of Extraconomy.",
  lp2CustBenefit2Title: "Earn cashback",
  lp2CustBenefit2Desc: "On eligible purchases, part of the value comes back to you in Extracredit.",
  lp2CustBenefit3Title: "Track everything in your wallet",
  lp2CustBenefit3Desc: "See balances and benefits without having to memorize rules.",
  lp2CustExtracreditTitle: "Your cashback becomes easy to understand.",
  lp2CustExtracreditDesc: "When a purchase generates cashback, the value appears as Extracredit. 1 Extracredit is worth 1 Euro and can be used according to the network's rules.",
  lp2CustExtrapayLink: "Discover Extrapay",
  lp2CustPraticaLabel: "In practice",
  lp2CustStep1Title: "You shop",
  lp2CustStep1Desc: "At a store or seller in the network.",
  lp2CustStep2Title: "The benefit appears",
  lp2CustStep2Desc: "Cashback and other benefits get linked to your account.",
  lp2CustStep3Title: "You use it whenever it makes sense",
  lp2CustStep3Desc: "Your wallet shows what's available.",
  lp2CustFaqEyebrow: "Quick questions",
  lp2CustFaqTitle: "Before you continue.",
  lp2CustFaqDesc: "See just what tends to raise questions at this stage.",
  lp2CustFaq1Q: "Do I need to pay to create an account?",
  lp2CustFaq1A: "No. Customer is the free profile for those who shop in the network.",
  lp2CustFaq2Q: "Do I need to understand Extrapay and EXC before shopping?",
  lp2CustFaq2A: "No. You can start by shopping and get to know these features only when they show up in your experience.",
  lp2CustFaq3Q: "Where do I see my benefits?",
  lp2CustFaq3A: "Benefits are linked to your account and shown in your wallet and the corresponding areas of the platform.",
  lp2CustCtaTitle: "Ready to get started?",
  lp2CustCtaDesc: "Create your account and discover Extraconomy through what matters most: using it.",
  lp2CustCtaButton: "Create free account",
  lp2PartnerSeoDescription: "Partner ProSilver plan to start selling online on Extraconomy.",
  lp2PartnerBadge: "Partner · ProSilver",
  lp2PartnerPill: "ProSilver",
  lp2PartnerH1: "Start selling online with your own storefront.",
  lp2PartnerHeroDesc: "For those who want to take the first step into online sales within Extraconomy.",
  lp2PartnerCta1: "Choose Partner",
  lp2PartnerCta2: "Compare plans",
  lp2PartnerBenefitsEyebrow: "What you get",
  lp2PartnerBenefitsTitle: "A plan built for your business' current moment.",
  lp2PartnerBenefitsDesc: "See first what really changes in your operation. Full details are available when you need them.",
  lp2PartnerBenefit1Title: "Your storefront in the network",
  lp2PartnerBenefit1Desc: "Showcase products and services in your own space.",
  lp2PartnerBenefit2Title: "Up to 50 listings",
  lp2PartnerBenefit2Desc: "An initial capacity to organize your offer without excess.",
  lp2PartnerBenefit3Title: "Be part of the ecosystem",
  lp2PartnerBenefit3Desc: "Sell to people who are already active in the Extraconomy network.",
  lp2PartnerStat1Label: "Capacity",
  lp2PartnerStat1Value: "Up to 50 listings",
  lp2PartnerStat2Label: "Registration",
  lp2PartnerStat2Value: "€150/year",
  lp2PartnerStat3Label: "Renewal",
  lp2PartnerStat3Value: "€15/year",
  lp2PartnerStatsDisclaimer: "Prices and conditions must be confirmed at the time of signing up. This page presents the plan's commercial structure in summary form.",
  lp2PartnerFaqEyebrow: "Quick questions",
  lp2PartnerFaqTitle: "Before you continue.",
  lp2PartnerFaqDesc: "See just what tends to raise questions at this stage.",
  lp2PartnerFaq1Q: "Can I change plans later?",
  lp2PartnerFaq1A: "The structure was organized to follow your operation's growth. Check the current conditions for plan changes.",
  lp2PartnerFaq2Q: "Is there a monthly fee?",
  lp2PartnerFaq2A: "The plans shown work with annual billing and annual renewal, according to each plan's conditions.",
  lp2PartnerFaq3Q: "Do I need to decide now?",
  lp2PartnerFaq3A: "No. Compare the plans and choose only when the differences make sense for your operation.",
  lp2PartnerCtaTitle: "Is this the moment for Partner?",
  lp2PartnerCtaDesc: "Sign up and continue with your operation's details.",
  lp2PartnerCtaButton: "Choose Partner",
  lp2SellerSeoDescription: "Seller StartSeller plan to expand your online sales operation.",
  lp2SellerBadge: "Seller · StartSeller",
  lp2SellerPill: "Most popular",
  lp2SellerH1: "Already selling online? Give your operation more room.",
  lp2SellerHeroDesc: "Seller is for those who need to expand their catalog and presence without complicating their routine.",
  lp2SellerCta1: "Choose Seller",
  lp2SellerCta2: "Compare plans",
  lp2SellerBenefitsEyebrow: "What you get",
  lp2SellerBenefitsTitle: "A plan built for your business' current moment.",
  lp2SellerBenefitsDesc: "See first what really changes in your operation. Full details are available when you need them.",
  lp2SellerBenefit1Title: "Bigger catalog",
  lp2SellerBenefit1Desc: "Up to 500 listings for an operation that has already gained scale.",
  lp2SellerBenefit2Title: "Sell within the network",
  lp2SellerBenefit2Desc: "Connect your offer to the Extraconomy marketplace.",
  lp2SellerBenefit3Title: "More room to grow",
  lp2SellerBenefit3Desc: "An intermediate structure for those who already have a sales routine.",
  lp2SellerStat1Label: "Capacity",
  lp2SellerStat1Value: "Up to 500 listings",
  lp2SellerStat2Label: "Registration",
  lp2SellerStat2Value: "€350/year",
  lp2SellerStat3Label: "Renewal",
  lp2SellerStat3Value: "€35/year",
  lp2SellerStatsDisclaimer: "Prices and conditions must be confirmed at the time of signing up. This page presents the plan's commercial structure in summary form.",
  lp2SellerFaqEyebrow: "Quick questions",
  lp2SellerFaqTitle: "Before you continue.",
  lp2SellerFaqDesc: "See just what tends to raise questions at this stage.",
  lp2SellerFaq1Q: "Can I change plans later?",
  lp2SellerFaq1A: "The structure was organized to follow your operation's growth. Check the current conditions for plan changes.",
  lp2SellerFaq2Q: "Is there a monthly fee?",
  lp2SellerFaq2A: "The plans shown work with annual billing and annual renewal, according to each plan's conditions.",
  lp2SellerFaq3Q: "Do I need to decide now?",
  lp2SellerFaq3A: "No. Compare the plans and choose only when the differences make sense for your operation.",
  lp2SellerCtaTitle: "Is this the moment for Seller?",
  lp2SellerCtaDesc: "Sign up and continue with your operation's details.",
  lp2SellerCtaButton: "Choose Seller",
  lp2ManagerSeoDescription: "Manager GeoGold plan for operations with a large catalog and territorial reach.",
  lp2ManagerBadge: "Manager · GeoGold",
  lp2ManagerPill: "GeoGold",
  lp2ManagerH1: "More reach for an operation that has already grown.",
  lp2ManagerHeroDesc: "Manager brings together resources for businesses with a large catalog and bigger territorial needs.",
  lp2ManagerCta1: "Choose Manager",
  lp2ManagerCta2: "Compare plans",
  lp2ManagerBenefitsEyebrow: "What you get",
  lp2ManagerBenefitsTitle: "A plan built for your business' current moment.",
  lp2ManagerBenefitsDesc: "See first what really changes in your operation. Full details are available when you need them.",
  lp2ManagerBenefit1Title: "Unlimited listings",
  lp2ManagerBenefit1Desc: "Build a large catalog with no listing cap.",
  lp2ManagerBenefit2Title: "Territorial presence",
  lp2ManagerBenefit2Desc: "Geolocation resources support operations with wider reach.",
  lp2ManagerBenefit3Title: "A more complete operation",
  lp2ManagerBenefit3Desc: "A layer designed for more mature commercial structures.",
  lp2ManagerStat1Label: "Capacity",
  lp2ManagerStat1Value: "Unlimited listings",
  lp2ManagerStat2Label: "Registration",
  lp2ManagerStat2Value: "€1,500/year",
  lp2ManagerStat3Label: "Renewal",
  lp2ManagerStat3Value: "€150/year",
  lp2ManagerStatsDisclaimer: "Prices and conditions must be confirmed at the time of signing up. This page presents the plan's commercial structure in summary form.",
  lp2ManagerFaqEyebrow: "Quick questions",
  lp2ManagerFaqTitle: "Before you continue.",
  lp2ManagerFaqDesc: "See just what tends to raise questions at this stage.",
  lp2ManagerFaq1Q: "Can I change plans later?",
  lp2ManagerFaq1A: "The structure was organized to follow your operation's growth. Check the current conditions for plan changes.",
  lp2ManagerFaq2Q: "Is there a monthly fee?",
  lp2ManagerFaq2A: "The plans shown work with annual billing and annual renewal, according to each plan's conditions.",
  lp2ManagerFaq3Q: "Do I need to decide now?",
  lp2ManagerFaq3A: "No. Compare the plans and choose only when the differences make sense for your operation.",
  lp2ManagerCtaTitle: "Is this the moment for Manager?",
  lp2ManagerCtaDesc: "Sign up and continue with your operation's details.",
  lp2ManagerCtaButton: "Choose Manager",
  lp2StoreSeoDescription: "Register your physical store for free on the Extraconomy map.",
  lp2StoreBadge: "Store · free",
  lp2StoreH1: "Put your store on the Extraconomy map.",
  lp2StoreHeroDesc: "Register your physical business for free and make it easier to find for people who are already part of the network.",
  lp2StoreCta1: "Register my store",
  lp2StoreCta2: "See how it works",
  lp2StoreBenefitsEyebrow: "Your store in the network",
  lp2StoreBenefitsTitle: "More visibility near people who are already looking.",
  lp2StoreBenefitsDesc: "Store is the simple way to bring a physical business into the ecosystem.",
  lp2StoreBenefit1Title: "Show up on the map",
  lp2StoreBenefit1Desc: "Help people in your area find your business.",
  lp2StoreBenefit2Title: "Join the network",
  lp2StoreBenefit2Desc: "Be part of a community of consumers, sellers, and promoters.",
  lp2StoreBenefit3Title: "Start at no cost",
  lp2StoreBenefit3Desc: "Store registration is free and designed to make it easy for local businesses to join.",
  lp2StoreLocalEyebrow: "For local businesses",
  lp2StoreLocalTitle: "Your physical presence still matters.",
  lp2StoreLocalDesc: "Extraconomy uses technology to bring people closer to real businesses. Store helps your shop be part of that local discovery.",
  lp2StoreLocalPhotoAlt: "Local business serving a customer",
  lp2StoreFaqEyebrow: "Quick questions",
  lp2StoreFaqTitle: "Before you continue.",
  lp2StoreFaqDesc: "See just what tends to raise questions at this stage.",
  lp2StoreFaq1Q: "Is Store registration free?",
  lp2StoreFaq1A: "Yes. Store is the free entry point for physical businesses.",
  lp2StoreFaq2Q: "Do I need to sell online?",
  lp2StoreFaq2A: "No. The Store profile exists for physical presence. If you want to sell online later, you can check out the Partner, Seller, and Manager plans.",
  lp2StoreFaq3Q: "Does the store show up for nearby people?",
  lp2StoreFaq3A: "The profile includes geolocated presence within the network, according to the features available on the platform.",
  lp2StoreCtaTitle: "Your store can already be part of it.",
  lp2StoreCtaDesc: "Register the basic details of your business and start with the free Store profile.",
  lp2StoreCtaButton: "Register store",
  lp2WhiteLabelSeoDescription: "Build your own network with Extraconomy's White Label infrastructure.",
  lp2WhiteLabelBadge: "White Label",
  lp2WhiteLabelH1: "A network with your organization's identity.",
  lp2WhiteLabelHeroDesc: "Use Extraconomy's technology to bring people, businesses, and benefits together in your own environment.",
  lp2WhiteLabelCta1: "Let's talk",
  lp2WhiteLabelCta2: "See how it works",
  lp2WhiteLabelBenefitsEyebrow: "Your network, your identity",
  lp2WhiteLabelBenefitsTitle: "The technology stays behind the scenes. Your community stays in front.",
  lp2WhiteLabelBenefitsDesc: "Associations, companies, and organizations can use Extraconomy's infrastructure without having to explain all the technical complexity to their members.",
  lp2WhiteLabelBenefit1Title: "Your own identity",
  lp2WhiteLabelBenefit1Desc: "The experience can take on the organization's visual identity and communication.",
  lp2WhiteLabelBenefit2Title: "Business network",
  lp2WhiteLabelBenefit2Desc: "Bring participants and businesses together in a shared environment.",
  lp2WhiteLabelBenefit3Title: "Connected benefits",
  lp2WhiteLabelBenefit3Desc: "Structure advantages and relationships within your ecosystem's logic.",
  lp2WhiteLabelStepsEyebrow: "From idea to use",
  lp2WhiteLabelStepsTitle: "Three steps to get started.",
  lp2WhiteLabelStepsDesc: "The rollout can be deepened later. First, we need to understand who is part of your network and what it needs to make possible.",
  lp2WhiteLabelStep1Label: "01 · Understand",
  lp2WhiteLabelStep1Title: "Who is part of your network?",
  lp2WhiteLabelStep1Desc: "We start with the people, businesses, and relationships that already exist.",
  lp2WhiteLabelStep2Label: "02 · Configure",
  lp2WhiteLabelStep2Title: "Which benefits make sense?",
  lp2WhiteLabelStep2Desc: "The structure is organized around the organization's goal.",
  lp2WhiteLabelStep3Label: "03 · Launch",
  lp2WhiteLabelStep3Title: "A simple experience to use.",
  lp2WhiteLabelStep3Desc: "The technical complexity stays behind the scenes; participation needs to stay clear.",
  lp2WhiteLabelCtaTitle: "Want to create your own network?",
  lp2WhiteLabelCtaDesc: "Tell us who you bring together and what you want to make possible.",
  lp2WhiteLabelCtaButton: "Talk about White Label",
  lp2PromoterSeoDescription: "Become an Extraconomy Promoter and help the network grow in your area.",
  lp2PromoterBadge: "Promoter · free",
  lp2PromoterH1: "Connect good businesses to the network.",
  lp2PromoterHeroDesc: "The Promoter introduces Extraconomy, brings people and businesses together, and helps the ecosystem grow locally.",
  lp2PromoterCta1: "I want to be a Promoter",
  lp2PromoterCta2: "Understand the role",
  lp2PromoterBenefitsEyebrow: "What you do",
  lp2PromoterBenefitsTitle: "You open doors. The network does the rest.",
  lp2PromoterBenefitsDesc: "The Promoter's role is to bring new businesses closer to Extraconomy and support their first contact with the ecosystem.",
  lp2PromoterBenefit1Title: "Introduce the idea",
  lp2PromoterBenefit1Desc: "Explain simply how a business can join the network.",
  lp2PromoterBenefit2Title: "Create real connections",
  lp2PromoterBenefit2Desc: "Bring together people and businesses that can generate value for each other.",
  lp2PromoterBenefit3Title: "Strengthen your area",
  lp2PromoterBenefit3Desc: "Help the network grow with businesses that exist near you.",
  lp2PromoterPayEyebrow: "Compensation",
  lp2PromoterPayTitle: "Compensation follows real activity.",
  lp2PromoterPayDesc: "Compensation rules are part of the compensation plan and are tied to the conditions and activities set by Extraconomy. Registration alone should not be treated as a sale.",
  lp2PromoterChecklistTitle: "Before you start",
  lp2PromoterChecklist1: "Understand how Extraconomy works so you can explain it clearly.",
  lp2PromoterChecklist2: "Connect businesses that have a real fit with the network.",
  lp2PromoterChecklist3: "Check the compensation plan before assuming any earnings expectations.",
  lp2PromoterCtaTitle: "Want to help the network grow?",
  lp2PromoterCtaDesc: "Start with registration and learn the rules before you act.",
  lp2PromoterCtaButton: "I want to be a Promoter",
  lp2EmpresasSeoDescription: "Bring Extraconomy to employees, customers, and partners with welfare, ESG, and B2B relationship solutions.",
  lp2EmpresasBadge: "For companies",
  lp2EmpresasH1: "Benefits that make sense for the people with you.",
  lp2EmpresasHeroDesc: "Bring Extraconomy to employees, customers, and partners with welfare, ESG, and B2B relationship solutions.",
  lp2EmpresasCta1: "Talk to Extraconomy",
  lp2EmpresasCta2: "Discover White Label",
  lp2EmpresasBenefitsEyebrow: "Solutions for companies",
  lp2EmpresasBenefitsTitle: "A benefits network can start in different ways.",
  lp2EmpresasBenefitsDesc: "Choose the point that fits your strategy and go deeper only where it makes sense.",
  lp2EmpresasBenefit1Title: "Welfare and benefits",
  lp2EmpresasBenefit1Desc: "Create advantages for people connected to your company.",
  lp2EmpresasBenefit2Title: "ESG with local relationships",
  lp2EmpresasBenefit2Desc: "Bring consumption, businesses, and impact closer within a nearby network.",
  lp2EmpresasBenefit3Title: "B2B relationships",
  lp2EmpresasBenefit3Desc: "Connect companies and business opportunities within the ecosystem.",
  lp2EmpresasWhiteLabelEyebrow: "Also for associations",
  lp2EmpresasWhiteLabelTitle: "Want a network with your organization's identity?",
  lp2EmpresasWhiteLabelDesc: "The White Label solution uses Extraconomy's infrastructure to create your own environment for participants, businesses, and benefits.",
  lp2EmpresasWhiteLabelLink: "Discover White Label",
  lp2EmpresasStepEyebrow: "One step at a time",
  lp2EmpresasStepTitle: "Start with the problem your company wants to solve.",
  lp2EmpresasStepDesc: "Our conversation starts from the need: benefits, relationships, a business network, or your own environment.",
  lp2EmpresasCtaTitle: "Shall we understand your case?",
  lp2EmpresasCtaDesc: "Tell us what your company needs. The solution comes after.",
  lp2EmpresasCtaButton: "Talk to the team",
  lp2PlanosSeoDescription: "Compare Store, Partner, Seller and Manager at Extraconomy.",
  lp2PlanosBreadcrumb: "Plans",
  lp2PlanosEyebrow: "Plans",
  lp2PlanosH1: "Choose by the size of your operation.",
  lp2PlanosHeroDesc:
    "Start free with Store or choose an online selling structure. Compare only what changes between plans.",
  lp2PlanosCompareEyebrow: "Simple comparison",
  lp2PlanosCompareTitle: "See the differences that really matter.",
  lp2PlanosCompareDesc: "If a plan makes sense, go to its page to learn the details.",
  lp2PlanosStoreDesc: "Physical store on the map.",
  lp2PlanosStoreItem1: "Free registration",
  lp2PlanosStoreItem2: "Geolocated account",
  lp2PlanosStoreItem3: "Certified on the map",
  lp2PlanosStoreCta: "Learn about Store",
  lp2PlanosPartnerDesc: "€150/year · up to 50 listings.",
  lp2PlanosPartnerItem1: "Online showcase",
  lp2PlanosPartnerItem2: "Economic network",
  lp2PlanosPartnerItem3: "Renewal €15/year",
  lp2PlanosPartnerCta: "Learn about Partner",
  lp2PlanosSellerDesc: "€350/year · up to 500 listings.",
  lp2PlanosSellerItem1: "Personal e-commerce",
  lp2PlanosSellerItem3: "Renewal €35/year",
  lp2PlanosSellerCta: "Learn about Seller",
  lp2PlanosManagerDesc: "€1,500/year · unlimited listings.",
  lp2PlanosManagerItem1: "Online store",
  lp2PlanosManagerItem2: "Geolocation",
  lp2PlanosManagerItem3: "Renewal €150/year",
  lp2PlanosManagerCta: "Learn about Manager",
  lp2PlanosDisclaimer: "Prices and conditions must be confirmed at the time of signup.",
  lp2PlanosCtaTitle: "Still not sure?",
  lp2PlanosCtaDesc: "Start with the free Store or take your time to learn about each plan.",
  lp2PlanosCtaButton: "Start with Store",
  lp2SobreSeoDescription: "Learn the idea behind Extraconomy and how its network connects people and businesses.",
  lp2SobreBadge: "About Extraconomy",
  lp2SobreH1: "A network built to keep value circulating.",
  lp2SobreHeroDesc: "Extraconomy brings together those who buy, those who sell and those who create new connections, strengthening closer economic relationships.",
  lp2SobreCta1: "See where I fit in",
  lp2SobreCta2: "For businesses",
  lp2SobreIdeaEyebrow: "Our idea",
  lp2SobreIdeaTitle: "Technology only makes sense when it improves real relationships.",
  lp2SobreIdeaDesc: "That's why Extraconomy brings together marketplace, benefits, loyalty and tools to help people, businesses and organizations take part in the same network.",
  lp2SobreValue1Title: "People at the center",
  lp2SobreValue1Desc: "The experience starts with what someone wants to do, not with the technology behind it.",
  lp2SobreValue2Title: "Real businesses",
  lp2SobreValue2Desc: "Physical stores and online sellers are part of the same connected economy.",
  lp2SobreValue3Title: "Value in circulation",
  lp2SobreValue3Desc: "Benefits encourage new relationships within the network itself.",
  lp2SobreInfraEyebrow: "From a marketplace to an infrastructure",
  lp2SobreInfraTitle: "The same logic can serve people, businesses and communities.",
  lp2SobreInfraDesc: "The marketplace is an important part. Extrapay, corporate solutions and White Label extend this foundation to other contexts without losing the core idea: connecting people and businesses simply.",
  lp2SobreInfraImgAlt: "Local business in the Extraconomy economy",
  lp2SobreCtaTitle: "Where do you fit in this network?",
  lp2SobreCtaDesc: "Choose by the activity that makes sense for you today.",
  lp2SobreCtaButton: "Explore profiles",
  lp2VideoEyebrow: "Meet Extraconomy",
  lp2VideoTitle: "An economy that stays with those who take part.",
  lp2VideoDescription: "In just a few minutes, our founder introduces the ecosystem that connects citizens, shops, professionals and associations in a single network of benefits.",
  lp2VideoLanguageNote: "Video in Italian, with automatic subtitles in your language. If they don't show up, turn them on with the player's CC button.",
  lp2VideoPlay: "Watch the video",
};

export default landingDictEN;
